module.exports = __webpack_public_path__ + "img/creator2.b0414a1.png";